const { createContext } = require("react");

const DashboardContext = createContext({
    username: '',
    isLogin: false,
    Authentication: '',
    handelusername: () => { },
    handelLogin: () => { },
    handelAuthentication: () => { },
    handelloding: () => { }
})
export default DashboardContext